import { mapEnumToOptions } from '@abp/ng.core';

export enum InformationSourceState {
  Inactive = 0,
  Active = 1,
}

export const informationSourceStateOptions = mapEnumToOptions(InformationSourceState);
